import React from 'react'

const Error = ({error, setError}) => { 
  const errormsgStyle = {
      background: '#7e7a7a',
      zIndex: '9999',
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
  }
  const errortxtStyle = {
      
      background: '#fff',
      width: '50%',
      height: '500px',
      margin: '120px auto',
      position: 'absolute',
      left: 0,
      right: 0,
      padding: '10px',
      display: 'flex',
      flexDirection:"column",
      marginLeft : 'auto',
      marginRight: 'auto',
      justifyContent: 'center',
      // alignItems: 'center',
      borderRadius: '7px'
  }
  const errorSpanStyle = {
    color: 'rgb(185, 0, 0)'
  }
  return (
    <div className="errormsg" style={errormsgStyle}>
        {/* <h3 className="errortxt" style={errortxtStyle}>{error}</h3> */}
        <div className="errortxt" style={errortxtStyle}>
          {
              Number(error?.id) != 403 ? <div  style={{margin:"0 20px"}}>
                You have encountered a temporary error. Please contact <a target="_blank" href="https://support.pearson.com/getsupport/s/contactsupport\"> Pearson Support </a> with a screenshot of this error page and webpage URL from your browser. We apologize for any inconvenience.
              </div> : ''
          }
          
          <div style={{margin:"20px 20px 0 20px"}}>
            <p>Error code: {error?.id}</p>
            <p >Error message: <span className='errorMsg' style={errorSpanStyle}>{error?.msg}</span></p>
          </div>
        </div>
        
    </div>
  )
}

export default Error